import { render, staticRenderFns } from "./messageTemplateCategoryDetail.vue?vue&type=template&id=6862cf15"
import script from "./messageTemplateCategoryDetail.vue?vue&type=script&lang=js"
export * from "./messageTemplateCategoryDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports